// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"3371d931","170":"d9b84c43","576":"fe85a2c7","837":"89ed09ec","944":"89dfc9c6"}[chunkId] + ".chunk.js";
};